import { render, staticRenderFns } from "./ModalDelegation.vue?vue&type=template&id=2bbb8f2a&"
import script from "./ModalDelegation.js?vue&type=script&lang=js&"
export * from "./ModalDelegation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports